const PAGE_TITLE = 'Translate Improvements';

const TRANSLATE_IMPROVEMENTS_PAGE_CONSTANTS = Object.freeze({
  pageSize: 10,
  pageTitle: PAGE_TITLE,
});

export { TRANSLATE_IMPROVEMENTS_PAGE_CONSTANTS };
